/*#########################################################
    ユーザー情報関連
#########################################################*/

// ## 住所一覧ヘッダーテンプレート ##
const template_header_index = document.getElementById('template_header_index') ? getCloneNode(document.getElementById('template_header_index')) : null;
const template_header_index_notfound = document.getElementById('template_header_index_notfound') ? getCloneNode(document.getElementById('template_header_index_notfound')) : null;
const target_header = document.getElementById('target_header') || null;

// ## 住所一覧テンプレート ##
const template_body_index = document.getElementById('template_body_index') ? getCloneNode(document.getElementById('template_body_index')) : null;
const target_address = document.getElementById('target_address') || null;

// ## 住所一覧セレクター ##
const address_selector = document.getElementById('address_selector') || null;

module.exports = {
    // 住所一覧データの取得
    index(callback = null, e_callback = null) {
        if (target_address) {
            target_address.innerHTML = spinner_border;
        }
        let data = api({
            api: '/api/user/address',
            _method: "GET",
            callback,
            e_callback,
        });
    },
    // 住所一覧データの表示
    index_showing(data) {
        target_address.querySelector('.spinner').remove();
        // ## 取得したデータをテンプレートに設定
        const d = data.data;
        if (d.length > 0) {
            target_header.innerHTML = template_header_index.innerHTML;
        } else {
            target_header.innerHTML = template_header_index_notfound.innerHTML;
        }
        for (let i in d) {
            template_body_index.querySelector('[data-content="title"]').innerHTML = d[i].is_default ? d[i].title + ' <span class="badge bg-primary">デフォルト</span>' : d[i].title;
            template_body_index.querySelector('[data-content="name"]').innerHTML = d[i].name;
            template_body_index.querySelector('[data-content="show"]').setAttribute('onclick', 'address.show(\'' + d[i].id + '\')');
            template_body_index.querySelector('[data-content="delete"]').setAttribute('onclick', 'address.delete(\'' + d[i].id + '\')');
            target_address.appendChild(template_body_index.cloneNode(true));
        }
    },
    // 住所データの取得
    show(id) {
        let data = api({
            api: '/api/user/address/' + id,
            callback: address.edit_showing,
        });
    },
    // 住所データの編集用modal表示
    edit_showing(data) {
        const d = data.data;
        const title_text = d.id ? 'お届け先の編集' : 'お届け先の新規登録';
        const title = `<i class="fas fa-address-book"></i> ${title_text}`;
        const body = setValuesHtml('template_edit', d);
        const footer_text = d.id ? '変更する' : '登録する';
        const footer =
            `<button type="button" class="btn btn-shadow btn-primary btn-block px-5" onclick="address.store();">
                ${footer_text} <i class="fas fa-arrow-circle-right"></i>
            </button>`;
        make_modal({ title, body, footer });
        // ## 動的に呼び出した要素にyubinbango.jsを発火 ##
        document.getElementById('modal').addEventListener('shown.bs.modal', (event) => {
            new YubinBango.MicroformatDom();
        });
    },
    // 住所データの保存
    store() {
        const form = document.getElementById('modal').querySelector('form');
        this.validator_reset();
        let formdata = new FormData(form);
        let address_id = formdata.get('id') || 'create';
        let data = api({
            api: '/api/user/address/' + address_id,
            _method: "PUT",
            formdata,
            callback: address.success,
            e_callback: address.validator
        });
    },
    // 住所データ保存成功時のコールバック
    success(data) {
        if (data.error == false) {
            if (target_address) {
                // 住所一覧を再表示
                address.index(address.index_showing);
            } else if (address_selector) {
                // 住所一覧を再表示
                address.index(address.selector);
            }
            // Modalを閉じる
            close_modal();
            // トーストを表示
            make_toast(data.toasts);

        }
    },
    // 住所データのバリデーション
    validator(data) {
        const form = document.getElementById('modal').querySelector('form');
        let errors = '';
        let this_errors = '';
        if (isset(data.validator)) {
            Object.keys(data.validator).forEach(function (id) {
                form.querySelector("#" + id).classList.add("is-invalid");
                this_errors = '';
                data.validator[id].forEach(function (error) {
                    this_errors += '<i class="fas fa-exclamation-circle"></i> ' + error + '<br>';
                    form.querySelector('.invalid-feedback[for="' + id + '"]').style.display = 'block';
                    form.querySelector('.invalid-feedback[for="' + id + '"]').innerHTML = this_errors;
                });
                errors += this_errors;
            });
            form.querySelector("#alert").innerHTML = errors;
            form.querySelector("#alert").style.display = 'block';
            document.getElementById('modal').scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    },
    // バリデーションのリセット
    validator_reset() {
        const form = document.getElementById('modal').querySelector('form');
        form.querySelector("#alert").style.display = 'none';
        form.querySelector("#alert").innerHTML = '';
        form.querySelectorAll('.is-invalid').forEach(function (dom) {
            dom.classList.remove("is-invalid");
        });
        form.querySelectorAll('.invalid-feedback').forEach(function (dom) {
            dom.innerHTML = '';
        });
    },
    // 削除用住所データの取得
    delete(id) {
        let data = api({
            api: '/api/user/address/' + id,
            callback: address.delete_showing
        });
    },
    // 住所データの削除用表示
    delete_showing(data) {
        const d = data.data;
        d.pref = pref[d.pref];
        const title = `<i class="far fa-trash-alt"></i> 削除しますか？`;
        const body = setTextHtml('template_del', d);
        const footer =
            `<button type="button" class="btn btn-danger btn-shadow px-4 px-md-5" data-content="destroy" onclick="address.destroy('${d.id}')">
            <i class="far fa-trash-alt"></i> 削除する
        </button>`;
        make_modal({ title, body, footer });
    },
    destroy(id) {
        let data = api({
            api: '/api/user/address/' + id,
            _method: "DELETE",
            callback: address.destroy_callback,
        });
    },
    // 住所データ削除成功時のコールバック
    destroy_callback(data) {
        // 住所一覧を再表示
        address.index(address.index_showing);
        // Modalを閉じる
        close_modal();
        // トーストを表示
        make_toast(data.toasts);
    },
    // 住所一覧セレクターの取得
    selector(d) {
        const selector = document.querySelector('[name="user_address_id"]');
        if (!selector) { return; }
        const selected_id = selector.value; // 再描画時に選択済みだった場合のID
        selector.innerHTML = '';
        d.data.forEach(function (data) {
            let option = document.createElement('option');
            option.value = data.id;
            option.innerHTML = data.title;
            option.innerHTML += data.is_default ? ' [デフォルト]' : '';
            selector.append(option);
        });
        const select_id = selected_id || selector.value; // 選択済みだったIDがなければ最初のIDをセット
        if (selector.querySelector('[value="' + select_id + '"]')) {
            selector.querySelector('[value="' + select_id + '"]').selected = true; // セットされたIDを選択状態にする
        }
        address.selector_show(d, select_id);
        selector.addEventListener('change', (event) => {
            event.preventDefault(); // 複数回発火防止
            address.selector_show(d, selector.value);
        });
    },
    // 選択した住所の描画
    selector_show(d, id) {
        let selected = d.data.filter(function (data) {
            return data.id == id;
        })[0];
        let text = '';
        if (isset(selected)) {
            text = '<button type="button" class="btn btn-outline-success btn-shadow float-end" onclick="address.show(\'' + selected.id + '\')"><i class="fas fa-pen-fancy"></i> 編集</button>';
            text += '〒' + selected.zip;
            text += '<br>';
            text += pref[selected.pref] + ' ';
            text += selected.city || '';
            text += '<br>';
            text += selected.street_address ? selected.street_address + ' ' : '';
            text += selected.apartment || '';
            text += '<br>';
            text += selected.company ? selected.company + ' ' : '';
            text += selected.department || '';
            text += '<br>';
            text += selected.name ? selected.name + ' 様' : '';
            text += '<br>';
            text += selected.tel || '';
        }
        document.querySelector('[data-content="address-text"]').innerHTML = text;
    }
}

